export const rolesMapping = {
  "vf-admin": "VF-Admin",
  "vf-viewer": "VF-Viewer",
  "vf-editor": "VF-Editor",
  superadmin: "Super Admin",
  admin: "Admin",
  editor: "Editor",
  commentor: "Commentor",
  viewer: "Viewer",
};
